/* ===== Anadita Luxe — core interactions ===== */
(function () {
  'use strict';
  var on = function (el, ev, fn) { if (el) el.addEventListener(ev, fn); };
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---- Mobile nav ---- */
  var mobileNav = $('[data-mobile-nav]');
  on($('[data-menu-toggle]'), 'click', function () {
    if (!mobileNav) return;
    var open = mobileNav.classList.toggle('is-open');
    this.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.style.overflow = open ? 'hidden' : '';
  });
  $$('[data-menu-close]').forEach(function (el) {
    on(el, 'click', function () {
      if (mobileNav) mobileNav.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  });

  /* ---- Search panel ---- */
  var searchPanel = $('[data-search-panel]');
  on($('[data-search-toggle]'), 'click', function () {
    if (!searchPanel) return;
    var hidden = searchPanel.hasAttribute('hidden');
    if (hidden) { searchPanel.removeAttribute('hidden'); var inp = $('input', searchPanel); if (inp) inp.focus(); }
    else searchPanel.setAttribute('hidden', '');
  });
  on($('[data-search-close]'), 'click', function () { if (searchPanel) searchPanel.setAttribute('hidden', ''); });

  /* ---- Scroll reveal ---- */
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var reveals = $$('.reveal');
  if (!reduced && 'IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else { reveals.forEach(function (el) { el.classList.add('is-visible'); }); }

  /* ---- Quick add (AJAX) ---- */
  $$('[data-quick-add]').forEach(function (form) {
    on(form, 'submit', function (e) {
      e.preventDefault();
      var btn = $('button', form);
      var orig = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: $('[name="id"]', form).value, quantity: 1 })
      }).then(function (r) { return r.json(); }).then(function () {
        return fetch('/cart.js').then(function (r) { return r.json(); });
      }).then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          if (el.hasAttribute('data-hide-when-empty')) el.hidden = cart.item_count === 0;
        });
        document.dispatchEvent(new CustomEvent('anadita:added'));
        if (btn) { btn.textContent = 'Added ✓'; setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1400); }
      }).catch(function () { if (btn) { btn.textContent = orig; btn.disabled = false; } });
    });
  });

  /* ---- Product variant + qty ---- */
  var productRoot = $('[data-product-root]');
  var variantSelect = $('[data-variant-select]', productRoot || document);
  var priceBlock = $('[data-price-block]', productRoot || document);
  var mainImg = $('#ProductMainImage');
  var thumbs = $$('[data-thumb]');
  var thumbsByMediaId = {};
  thumbs.forEach(function (thumb) {
    var mediaId = String(thumb.dataset.mediaId || '');
    if (mediaId) thumbsByMediaId[mediaId] = thumb;
  });
  var variantsJsonEl = $('[data-product-variants]', productRoot || document);
  var variants = [];
  if (variantsJsonEl) {
    try { variants = JSON.parse(variantsJsonEl.textContent || '[]'); }
    catch (e) { variants = []; }
  }

  function setMainImage(url) {
    if (!mainImg || !url) return;
    var current = mainImg.getAttribute('src') || '';
    if (current === url) return;
    // Main image is rendered with responsive srcset; clear it before manual swap.
    mainImg.removeAttribute('srcset');
    mainImg.removeAttribute('sizes');
    mainImg.src = url;
  }

  function setActiveThumbByMediaId(mediaId) {
    if (!mediaId) return;
    var key = String(mediaId);
    var activeThumb = thumbsByMediaId[key] || null;
    thumbs.forEach(function (thumb) {
      var isActive = String(thumb.dataset.mediaId || '') === String(mediaId);
      thumb.classList.toggle('is-active', isActive);
    });
    if (activeThumb && activeThumb.dataset.thumb) setMainImage(activeThumb.dataset.thumb);
  }

  // Preload gallery image URLs for faster first variant and thumb switches.
  if (thumbs.length && 'requestIdleCallback' in window) {
    window.requestIdleCallback(function () {
      thumbs.forEach(function (thumb) {
        if (!thumb.dataset.thumb) return;
        var img = new Image();
        img.src = thumb.dataset.thumb;
      });
    }, { timeout: 1200 });
  }

  function getChosenOptionValues() {
    var checked = $$('[data-option-selector]:checked', productRoot || document);
    if (!checked.length) return [];
    var ordered = [];
    checked.forEach(function (input) {
      var pos = parseInt(input.dataset.optionPosition || '0', 10);
      if (pos > 0) ordered[pos - 1] = input.value;
    });
    return ordered.filter(function (v) { return typeof v !== 'undefined'; });
  }

  function findVariantByOptions(optionValues) {
    if (!variants.length || !optionValues.length) return null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var candidate = [v.option1, v.option2, v.option3].slice(0, optionValues.length);
      var same = true;
      for (var j = 0; j < optionValues.length; j++) {
        if (candidate[j] !== optionValues[j]) { same = false; break; }
      }
      if (same) return v;
    }
    return null;
  }

  function syncVariant() {
    if (!variantSelect) return;
    var chosenVariant = findVariantByOptions(getChosenOptionValues());
    if (chosenVariant && chosenVariant.id) variantSelect.value = String(chosenVariant.id);

    var sel = variantSelect.options[variantSelect.selectedIndex];
    var sticky = $('[data-sticky-price]');
    var atcBtn = $('[data-atc]', productRoot || document);
    var atcText = $('[data-atc-text]', productRoot || document);
    if (sel && sel.dataset.price) {
      if (priceBlock) { var reg = $('.price__regular', priceBlock); if (reg) reg.textContent = sel.dataset.price; }
      if (sticky) sticky.textContent = sel.dataset.price;
    }
    if (sel && sel.dataset.media) setActiveThumbByMediaId(sel.dataset.media);

    if (atcBtn) {
      var soldOut = !!(sel && sel.disabled);
      atcBtn.disabled = soldOut;
      if (atcText) {
        var defaultLabel = atcText.dataset.defaultText || 'Add to cart';
        var soldOutLabel = atcText.dataset.soldoutText || 'Sold out';
        atcText.textContent = soldOut ? soldOutLabel : defaultLabel;
      }
    }
  }

  $$('[data-option-selector]', productRoot || document).forEach(function (radio) {
    on(radio, 'change', function () {
      var label = radio.closest('.product__swatches');
      if (label) $$('.swatch', label).forEach(function (s) { s.classList.remove('is-selected'); });
      var wrap = radio.closest('.swatch'); if (wrap) wrap.classList.add('is-selected');
      syncVariant();
    });
  });
  on(variantSelect, 'change', function () { syncVariant(); });

  $$('[data-qty-minus]').forEach(function (b) { on(b, 'click', function () { var i = $('[data-qty-input]', b.parentNode); if (i) i.value = Math.max(1, (parseInt(i.value, 10) || 1) - 1); }); });
  $$('[data-qty-plus]').forEach(function (b) { on(b, 'click', function () { var i = $('[data-qty-input]', b.parentNode); if (i) i.value = (parseInt(i.value, 10) || 1) + 1; }); });

  /* ---- Product gallery thumbs ---- */
  thumbs.forEach(function (t) {
    on(t, 'click', function () {
      setMainImage(t.dataset.thumb);
      thumbs.forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
    });
  });

  /* ---- Cart line updates ---- */
  function changeLine(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function () { window.location.reload(); });
  }
  $$('[data-cart-minus]').forEach(function (b) { on(b, 'click', function () { var i = $('[data-cart-qty="' + b.dataset.cartMinus + '"]'); changeLine(b.dataset.cartMinus, Math.max(0, (parseInt(i.value, 10) || 1) - 1)); }); });
  $$('[data-cart-plus]').forEach(function (b) { on(b, 'click', function () { var i = $('[data-cart-qty="' + b.dataset.cartPlus + '"]'); changeLine(b.dataset.cartPlus, (parseInt(i.value, 10) || 1) + 1); }); });
  /* ---- Product form -> drawer (only when drawer present) ---- */
  var pForm = $('[data-product-form]');
  if (pForm && document.querySelector('[data-cart-drawer]')) {
    on(pForm, 'submit', function (e) {
      e.preventDefault();
      var currentOption = pForm.querySelector('[data-variant-select] option:checked');
      if (currentOption && currentOption.disabled) return;
      var addBtn = $('[data-atc]', pForm);
      var label = addBtn ? $('[data-atc-text]', addBtn) : null;
      var orig = label ? (label.dataset.defaultText || label.textContent) : '';
      if (label) label.textContent = 'Adding…';
      if (addBtn) addBtn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(pForm) })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) throw data;
            return data;
          });
        })
        .then(function () { document.dispatchEvent(new CustomEvent('anadita:added')); if (label) label.textContent = orig; if (addBtn) addBtn.disabled = false; })
        .catch(function () { if (label) label.textContent = orig; if (addBtn) addBtn.disabled = false; pForm.submit(); });
    });
  }

  /* ---- Product carousel ---- */
  $$('[data-carousel]').forEach(function (carousel) {
    var dotsContainer = carousel.nextElementSibling?.querySelector('[data-dots]');
    if (!dotsContainer) return; // Only init if carousel controls present
    var prevBtn = carousel.nextElementSibling?.querySelector('.carousel-prev');
    var nextBtn = carousel.nextElementSibling?.querySelector('.carousel-next');
    var cards = $$('[data-product-grid] > *', carousel.parentNode);
    if (!cards.length) return;

    function updateDots() {
      var scrollLeft = carousel.scrollLeft;
      var cardWidth = cards[0]?.offsetWidth || 0;
      var gap = 18;
      var currentIdx = Math.round(scrollLeft / (cardWidth + gap));
      $$('.carousel-dot', dotsContainer).forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === currentIdx);
      });
    }

    // Scroll fires at high frequency; rAF-coalesce so each scroll frame does
    // at most one layout read/write instead of one per native scroll event.
    var dotsRaf = null;
    function onCarouselScroll() {
      if (dotsRaf) return;
      dotsRaf = window.requestAnimationFrame(function () {
        dotsRaf = null;
        updateDots();
      });
    }

    function initDots() {
      dotsContainer.innerHTML = '';
      var cardWidth = cards[0]?.offsetWidth || 0;
      var viewportWidth = carousel.offsetWidth;
      var cardsPerView = Math.floor(viewportWidth / (cardWidth + 18));
      var numDots = Math.ceil((cards.length - cardsPerView) / 1) + 1;
      for (var i = 0; i < numDots; i++) {
        var dot = document.createElement('button');
        dot.className = 'carousel-dot';
        if (i === 0) dot.classList.add('is-active');
        dot.addEventListener('click', function () {
          var scrollPos = i * (cardWidth + 18);
          carousel.scrollTo({ left: scrollPos, behavior: 'smooth' });
        });
        dotsContainer.appendChild(dot);
      }
    }

    function scroll(direction) {
      var cardWidth = cards[0]?.offsetWidth || 0;
      var gap = 18;
      var scrollAmount = cardWidth + gap;
      carousel.scrollBy({ left: direction * scrollAmount, behavior: 'smooth' });
    }

    if (prevBtn) on(prevBtn, 'click', function () { scroll(-1); });
    if (nextBtn) on(nextBtn, 'click', function () { scroll(1); });
    carousel.addEventListener('scroll', onCarouselScroll, { passive: true });

    initDots();
    setTimeout(function() { updateDots(); }, 100);
  });

  /* ---- Sticky header on scroll ---- */
  var header = $('[data-header]');
  if (header) {
    var last = 0;
    window.addEventListener('scroll', function () {
      var y = window.pageYOffset;
      header.classList.toggle('header--scrolled', y > 60);
      last = y;
    }, { passive: true });
  }
})();
